import { PredefinedFilter } from 'app/filter.utils'
import { defaultBecameLeadDateFilter } from 'app/utils/defaultBecameLeadDateFilter'

export const defaultNonPatientFilter: PredefinedFilter = {
  patientStatus: { operator: `not_in`, value: [`NonPatient`] },
}

export { defaultBecameLeadDateFilter }
